import {gql} from "@apollo/client";
import {ProductFragment} from "./Product";
import {StorageFragment} from "./Storage";
import {CategoryFragment} from "./Category";
import {BrandFragment} from "./Brand";
import {BannerFragment} from "./Banner";
import {DesignBlockCardFragment} from "./DesignBlockCard";
import {DesignBlockTextFragment} from "./DesignBlockText";
import {DesignBlockProductFragment} from "./DesignBlockProduct";
import {ProductFragmentAdmin} from "./Product";
import {DesignBlockCategoryFragment} from "./DesignBlockCategory";
import {CategoryFragmentAdmin} from "./Category";
import {DesignBlockBrandFragment} from "./DesignBlockBrand";
import {BrandFragmentAdmin} from "./Brand";
import {DesignBlockBannerFragment} from "./DesignBlockBanner";
import {BannerFragmentAdmin} from "./Banner";
import {DesignBlockCardFragmentAdmin} from "./DesignBlockCard";
import {DesignBlockTextFragmentAdmin} from "./DesignBlockText";

export const DesignBlockFragment = gql`
	fragment DesignBlockFragment on DesignBlock {
		id
		type
		position
		active
		title_in_color
		title_position
		full_width
		margin_top
		margin_bottom
		min_height
		background
		title
		subtitle
		var_1
		var_2
		var_3
		var_4
		var_5
		block_start
		block_end
	}
`

export const DesignBlockFragmentAdmin = gql`
	fragment DesignBlockFragmentAdmin on DesignBlock {
		id
		type
		position
		active
		title_in_color
		title_position
		full_width
		margin_top
		margin_bottom
		min_height
		background
		title
		titles
		subtitle
		subtitles
		var_1
		var_2
		var_3
		var_4
		var_5
		block_start
		block_end
	}
`

export const GetDesignBlocks = gql`
	${DesignBlockFragment}
	${ProductFragment}
	${StorageFragment}
	${CategoryFragment}
	${BrandFragment}
	${BannerFragment}
	${DesignBlockCardFragment}
	${DesignBlockTextFragment}
	query ($code: String!, $active: Boolean, ) {
		GetDesignBlocks (code: $code, active: $active, ) 
	{
			...DesignBlockFragment
			products			{
				...ProductFragment
				image				{
					...StorageFragment
				}
				categories				{
					...CategoryFragment
				}
				brand				{
					...BrandFragment
				}
				connected				{
					...ProductFragment
					image					{
						...StorageFragment
					}
				}
			}
			categories			{
				...CategoryFragment
			}
			brands			{
				...BrandFragment
				image				{
					...StorageFragment
				}
			}
			banners			{
				...BannerFragment
				image				{
					...StorageFragment
				}
				mobile_image				{
					...StorageFragment
				}
			}
			cards			{
				...DesignBlockCardFragment
				image				{
					...StorageFragment
				}
			}
			text			{
				...DesignBlockTextFragment
			}
		}
	}
`

export const GetDesignBlocksAdmin = gql`
	${DesignBlockFragmentAdmin}
	${DesignBlockProductFragment}
	${ProductFragmentAdmin}
	${StorageFragment}
	${DesignBlockCategoryFragment}
	${CategoryFragmentAdmin}
	${DesignBlockBrandFragment}
	${BrandFragmentAdmin}
	${DesignBlockBannerFragment}
	${BannerFragmentAdmin}
	${DesignBlockCardFragmentAdmin}
	${DesignBlockTextFragmentAdmin}
	query ($code: String!, ) {
		GetDesignBlocksAdmin (code: $code, ) 
	{
			...DesignBlockFragmentAdmin
			design_blocks_products			{
				...DesignBlockProductFragment
				product				{
					...ProductFragmentAdmin
					image					{
						...StorageFragment
					}
				}
			}
			design_blocks_categories			{
				...DesignBlockCategoryFragment
				category				{
					...CategoryFragmentAdmin
				}
			}
			design_blocks_brands			{
				...DesignBlockBrandFragment
				brand				{
					...BrandFragmentAdmin
					image					{
						...StorageFragment
					}
				}
			}
			design_blocks_banners			{
				...DesignBlockBannerFragment
				banner				{
					...BannerFragmentAdmin
					images					{
						...StorageFragment
					}
					mobile_images					{
						...StorageFragment
					}
				}
			}
			cards			{
				...DesignBlockCardFragmentAdmin
				image				{
					...StorageFragment
				}
			}
			text			{
				...DesignBlockTextFragmentAdmin
			}
		}
	}
`

export const CreateDesignBlock = gql`
	${DesignBlockFragmentAdmin}
	mutation ($code: String, $type: String, $position: Int, ) {
		CreateDesignBlock (code: $code, type: $type, position: $position, ) {
			...DesignBlockFragmentAdmin
		}
	}
`

export const UpdateDesignBlock = gql`
	${DesignBlockFragmentAdmin}
	mutation ($id: ID!, $title: String, $title_position: String, $subtitle: String, $active: Boolean, $block_start: String, $block_end: String, $title_in_color: Boolean, $full_width: Boolean, $margin_bottom: String, $margin_top: String, $min_height: Int, $background: String, $var_1: String, $var_2: String, $var_3: String, $var_4: String, $var_5: String, $attach_products: [ID], $attach_categories: [ID], $attach_brands: [ID], $attach_banner: ID, ) {
		UpdateDesignBlock (id: $id, title: $title, title_position: $title_position, subtitle: $subtitle, active: $active, block_start: $block_start, block_end: $block_end, title_in_color: $title_in_color, full_width: $full_width, margin_bottom: $margin_bottom, margin_top: $margin_top, min_height: $min_height, background: $background, var_1: $var_1, var_2: $var_2, var_3: $var_3, var_4: $var_4, var_5: $var_5, attach_products: $attach_products, attach_categories: $attach_categories, attach_brands: $attach_brands, attach_banner: $attach_banner, ) {
			...DesignBlockFragmentAdmin
		}
	}
`

export const DeleteDesignBlock = gql`
	${DesignBlockFragmentAdmin}
	mutation ($id: ID!, ) {
		DeleteDesignBlock (id: $id, ) {
			...DesignBlockFragmentAdmin
		}
	}
`

